<template lang="pug">
  .yz-control-group(:class="{ 'yz-control-group--horizontal': direction === 'horizontal', 'yz-control-group--vertical': direction === 'vertical', 'yz-control-group--error': hasError }" :style="groupStyles")
    slot
</template>

<script>
export default {
  name: 'YzControlGroup',
  props: {
    /**
     * Direction of the controls - vertical or horizontal
     */
    direction: {
      type: String,
      default: 'vertical',
      validator: value => ['vertical', 'horizontal'].includes(value)
    },
    /**
     * Spacing between controls in pixels
     */
    spacing: {
      type: [Number, String],
      default: 16
    },
    /**
     * Whether the control group has an error state
     */
    hasError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    groupStyles() {
      const spacing = typeof this.spacing === 'number' ? `${this.spacing}px` : this.spacing;
      return {
        '--yz-control-group-spacing': spacing
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.yz-control-group {
  display: flex;
  width: 100%;

  &--vertical {
    flex-direction: column;
    gap: var(--yz-control-group-spacing, 12px);
  }

  &--horizontal {
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--yz-control-group-spacing, 12px);

    // Ensure proper alignment of controls in horizontal mode
    & > :deep(.yz-checkbox),
    & > :deep(.yz-radio) {
      margin-right: 0; // Override any default margins
    }
  }
}
</style>
